class RouteMonitor {
  eventName: string;

  eventFn: () => void;

  originPushState: (typeof window.history)['pushState'];

  originReplaceState: (typeof window.history)['replaceState'];

  constructor(eventName: string, fn: () => void) {
    this.eventFn = fn;
    this.eventName = eventName;
    this.originPushState = window.history.pushState;
    this.originReplaceState = window.history.replaceState;
    this.startHistoryListener();
  }

  startHistoryListener = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-this-alias, consistent-this
    const monitorInstance = this;
    window.addEventListener(monitorInstance.eventName, monitorInstance.eventFn);

    window.history.pushState = function (...arg) {
      const ret = monitorInstance.originPushState.apply(this, arg);
      const evt = new CustomEvent(monitorInstance.eventName);
      window.dispatchEvent(evt);
      return ret;
    };

    window.history.replaceState = function (...arg) {
      const ret = monitorInstance.originReplaceState.apply(this, arg);
      const evt = new CustomEvent(monitorInstance.eventName);
      window.dispatchEvent(evt);
      return ret;
    };

    window.addEventListener('popstate', (e: PopStateEvent) => {
      if (!e.garfish) {
        const evt = new CustomEvent(monitorInstance.eventName);
        window.dispatchEvent(evt);
      }
    });
  };
}

export default RouteMonitor;
